import React from "react";

/**
 * Logo Geodonnée en vectoriel : épingle et parcelles, puis « Géo Données ».
 * Le fichier d'origine (100 × 100 px) est trop petit pour rester lisible.
 * `clair` : version pour les fonds pétrole.
 */
export const Logo = ({ clair = false, className = "" }) => {
  const encre = clair ? "#FFFFFF" : "#083D44";
  const fond = clair ? "#083D44" : "#FFFFFF";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        viewBox="0 0 40 50"
        className="h-[2.75rem] w-auto flex-none lg:h-[3.25rem]"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M20 1.5C9.8 1.5 2.5 9.2 2.5 19c0 12.6 17.5 29.5 17.5 29.5S37.5 31.6 37.5 19C37.5 9.2 30.2 1.5 20 1.5Z"
          fill={encre}
        />
        <circle cx="20" cy="17.5" r="7" fill={fond} />
        <path d="M11.5 28.5 19 25.5l2 6.5-6.8 2.6Z" fill="#3D9E8B" />
        <path d="M21 25l7.6 2.7-3.9 6.5-1.8-2.4Z" fill="#2F7A3E" />
      </svg>
      <span
        className={`font-display text-[1.125rem] font-bold leading-[1.05] tracking-[-0.01em] lg:text-[1.3125rem] ${
          clair ? "text-white" : "text-brand"
        }`}
      >
        Géo
        <br />
        Données
      </span>
    </span>
  );
};
